module.exports = __webpack_public_path__ + "static/OneClickDeploy-81a914bda48382a201814b42f0f10d38.png";